import axios from "axios";

import type {IAccount, IUser} from "@mytour/shared";
import {Storage} from "../../utils/storage.util.js";

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ResetPasswordInitRequest {
  email: string;
}

export interface ResetPasswordFinishRequest {
  key: string;
  newPassword: string;
}

export const accountApiService = {
  async getAccount(): Promise<IAccount> {
    const response = await axios.get("api/account");
    return response.data;
  },

  async changePassword(request: ChangePasswordRequest): Promise<void> {
    await axios.post("api/account/change-password", request);
  },

  async resetPasswordInit(email: string): Promise<void> {
    // Content-Type must be text/plain as per original implementation
    await axios.post("api/account/reset-password/init", email, {
      headers: {"Content-Type": "text/plain"},
    });
  },

  async resetPasswordFinish(request: ResetPasswordFinishRequest): Promise<void> {
    await axios.post("api/account/reset-password/finish", request);
  },

  async updateAccount(account: IUser): Promise<IAccount> {
    const response = await axios.post("api/account", account);

    if (Storage.session.get("locale")) {
      Storage.session.remove("locale");
    }

    return response.data;
  },

  async ignoreOnboarding(): Promise<void> {
    await axios.post("api/account/ignore-onboarding/");
  },
};
